import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';
import bancoDeChilePalette from '@fingo/lib/theme/banco-de-chile/palette';
import fingoComponents from '@fingo/lib/theme/fingo/components';
import bancoDeChileComponents from '@fingo/lib/theme/banco-de-chile/components';
import bchTypography from '@fingo/lib/theme/banco-de-chile/typography';
import bchBranding from '@fingo/lib/theme/banco-de-chile/branding';
import ThemeStrategy from './ThemeStrategy';

class BCHThemeStrategy extends ThemeStrategy {
  constructor() {
    super();
    this.platformCode = REQUESTING_PLATFORM_TO_CODES.BCH;
    this.palette = bancoDeChilePalette;
    this.components = {
      ...fingoComponents,
      ...bancoDeChileComponents,
    };
    this.typography = bchTypography;
    this.branding = bchBranding;
  }

  getPlatformCode() {
    return this.platformCode;
  }

  getPalette() {
    return this.palette;
  }

  getComponents() {
    return this.components;
  }

  getTypography() {
    return this.typography;
  }

  getBranding() {
    return this.branding;
  }
}

export default BCHThemeStrategy;
